import { startTransition, useEffect, useRef } from 'react';
import { appLaunchFlow } from '../../redux/authentication/action';
import { useDispatch } from 'react-redux';

const APILoader = () => {
    const normalDispatch = useDispatch();
    const dispatchedRef = useRef(false);

    useEffect(() => {
        if (dispatchedRef.current) return;
        dispatchedRef.current = true;

        /** Defer launch navigation so lazy route chunks don't suspend during sync hydration (React #426). */
        startTransition(() => {
            normalDispatch(appLaunchFlow());
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export { APILoader };
